import { render, staticRenderFns } from "./TreeTest.vue?vue&type=template&id=6045bb4e"
import script from "./TreeTest.vue?vue&type=script&lang=js"
export * from "./TreeTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports